<ion-content class="maintenance-modal">
  <div class="maintenance-modal__container">
    <div class="maintenance-modal__logo" aria-hidden="true"></div>
    <ion-icon class="maintenance-modal__icon" name="construct"></ion-icon>
    <h2 class="maintenance-modal__title">
      {{ message || "We're currently undergoing some routine maintenance to improve the app. We'll be back very soon!" }}
    </h2>
    <p class="maintenance-modal__support">
      {{ support || 'If you need additional assistance, please email support@penmateapp.com.' }}
    </p>
    <ion-button expand="block" color="primary" (click)="onContactSupport()">
      Contact Support
    </ion-button>
  </div>
</ion-content>
